module.exports = __webpack_public_path__ + "img/logo_wibo.e1376e0a.png";